var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25033 11.4583C1.25033 11.8341 1.39958 12.1944 1.66526 12.4601C1.93093 12.7257 2.29127 12.875 2.66699 12.875H8.33366C8.70938 12.875 9.06972 12.7257 9.33539 12.4601C9.60107 12.1944 9.75033 11.8341 9.75033 11.4583V2.95833H1.25033V11.4583ZM2.66699 4.375H8.33366V11.4583H2.66699V4.375ZM7.97949 0.833333L7.27116 0.125H3.72949L3.02116 0.833333H0.541992V2.25H10.4587V0.833333H7.97949Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcons);
export default __webpack_public_path__ + "static/media/trashIcons.e6d62d87a42360f65be0fdf2a37470e8.svg";
export { ForwardRef as ReactComponent };